import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HiPlay, HiLocationMarker, HiClock, HiStar } from 'react-icons/hi';
import Header from '../components/Header';
import './BrandOption3.css';

export default function BrandOption3({ config }) {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadGames();
  }, []);

  const loadGames = async () => {
    try {
      const res = await fetch(`${config.apiUrl}/games`);
      const data = await res.json();
      setGames(data.data.games || []);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const liveGames = games.filter(g => g.status === 'live');
  const upcomingGames = games.filter(g => g.status === 'scheduled' || g.status === 'ready');
  const recordedGames = games.filter(g => g.status === 'recorded' && g.recordingUrl);

  const logo = <HiStar className="header-logo-icon prime" />;

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="brand3">
      <Header logo={logo} brandName="PRIME STREAM" theme="light" />
      
      <main className="main-content">
        <section className="hero-section prime-hero">
          <h1>Premium Sports Experience</h1>
          <p>Sophisticated streaming for discerning fans</p>
        </section>

        {liveGames.length > 0 && (
          <section className="games-section">
            <h2>Live Now</h2>
            <div className="games-grid">
              {liveGames.map(game => (
                <Link key={game.gameId} to={`/watch/${game.gameId}`} className="game-card prime-live">
                  <div className="card-badge prime-badge">LIVE</div>
                  <h3>{game.homeTeam} vs {game.awayTeam}</h3>
                  <div className="card-info">
                    <HiLocationMarker /> {game.venue}
                  </div>
                  <button className="watch-btn prime-btn">
                    <HiPlay /> Watch Now
                  </button>
                </Link>
              ))}
            </div>
          </section>
        )}

        {upcomingGames.length > 0 && (
          <section className="games-section">
            <h2>Upcoming</h2>
            <div className="games-grid">
              {upcomingGames.slice(0, 6).map(game => (
                <div key={game.gameId} className="game-card">
                  <h3>{game.homeTeam} vs {game.awayTeam}</h3>
                  <div className="card-info">
                    <HiLocationMarker /> {game.venue}
                  </div>
                  <div className="card-info">
                    <HiClock /> {new Date(game.scheduledStart).toLocaleString('en-US', { 
                      month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' 
                    })}
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {recordedGames.length > 0 && (
          <section className="games-section">
            <h2>Replays</h2>
            <div className="games-grid">
              {recordedGames.slice(0, 6).map(game => (
                <Link key={game.gameId} to={`/watch/${game.gameId}`} className="game-card replay-card">
                  {game.thumbnailUrl && (
                    <div className="replay-thumbnail">
                      <img src={game.thumbnailUrl} alt="Match" />
                      <div className="thumbnail-overlay">
                        <HiPlay className="play-icon-large" />
                      </div>
                    </div>
                  )}
                  <div className="replay-content">
                    <div className="card-badge prime-badge">REPLAY</div>
                    <h3>{game.homeTeam} vs {game.awayTeam}</h3>
                    <div className="card-info">
                      <HiLocationMarker /> {game.venue}
                    </div>
                    <button className="watch-btn prime-btn">
                      <HiPlay /> Watch Now
                    </button>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        )}
      </main>
    </div>
  );
}
